<template lang="">
  <div class="mains">
    <div class="header_title">微信公众号配置</div>
    <div class="container">
      <div class="top"></div>
      <div class="main">
        <Form
          :model="gd"
          :label-width="180"
          style="width: 100%; max-width: 600px; min-width: 300px"
        >
          <FormItem label="开发者ID(AppID)">
            <Input
              v-model="gd.key"
              type="text"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="APPID"
            ></Input>
          </FormItem>
          <FormItem label="开发者密码(AppSecret)">
            <Input
              v-model="gd.secret"
              type="text"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="输入AppSecret"
            ></Input>
          </FormItem>

          <FormItem>
            <Button type="primary" @click="upGDkeys()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
    <div class="bottom_hint">
      温馨提示：<br>
      &ensp;1.请将<a style="color:red;"> 115.29.243.152 </a>添加到 -> 设置与开发 -> 基本配置 -> 公众号开发信息 -> IP白名单<br>
      &ensp;2.设置<a style="color:red;"> 3,4 </a>项时请先将<a style="color:red;"> .txt </a>文件交给技术人员上传<br>
      &ensp;3.请将<a style="color:red;"> yuan.gzxb315.com </a>添加到 -> 设置与开发 -> 公众号设置 -> 功能设置 -> JS接口安全域名<br>
      &ensp;4.请将<a style="color:red;"> yuan.gzxb315.com </a>添加到 -> 设置与开发 -> 公众号设置 -> 功能设置 -> 网页授权域名<br>
    </div>
  </div>
</template>1
<script>
import { upGDkey } from "@/api/index";
export default {
  data() {
    return {
      formItem: {
        valueA: "",
        valueB: "",
      },
      gd: {
        key: "",
        secret: "",
        map: "",
      },
    };
  },
  methods: {
    upGDkeys() {
      if (this.gd.key == "") {
        this.$Notice.error({ title: "请输入key" });
      } else if (this.gd.secret == "") {
        this.$Notice.error({ title: "请输入你的密钥" });
      } else if (this.gd.map == "") {
        this.$Notice.error({ title: "请输入map" });
      } else {
        upGDkey({
          keys: this.gd.key,
          secret: this.gd.secret,
          map: this.gd.map,
        }).then((res) => {
          if (res.code == 200) {
            const gd = {
              key: this.gd.key,
              secret: this.gd.secret,
              map: this.gd.map,
            };
            this.$store.commit("ChangGd", gd);
            this.$Notice.success({ title: "修改成功" });
          } else {
            this.$Notice.error({ title: "修改失败！", message: res.data });
          }
        });
      }
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
